const TRANSLATION = {
  common: {
    loading: 'Đang tải',
  },
  i18n: {
    English: 'Tiếng Anh',
    Spanish: 'Tiếng Tây Ban Nha',
    Russian: 'Tiếng Nga',
    'Portuguese (Brazil)': 'Tiếng Bồ Đào Nha (Brazil)',
    Indonesian: 'Tiếng Indonesia',
    Czech: 'Tiếng Séc',
    German: 'Tiếng Đức',
    French: 'Tiếng Pháp',
    Italian: 'Tiếng Ý',
    Dutch: 'Tiếng Hà Lan',
    Polish: 'Tiếng Ba Lan',
    Vietnamese: 'Tiếng Việt',
    Turkish: 'Tiếng Thổ Nhĩ Kỳ',
    Ukrainian: 'Tiếng Ukraina',
    Chinese: 'Tiếng Trung giản thể',
    'Traditional Chinese': 'Tiếng Trung truyền thống',
    Japanese: 'Tiếng Nhật',
    Korean: 'Tiếng Hàn',
    Arabic: 'Tiếng Ả Rập',
    Persian: 'Tiếng Ba Tư',
    Thai: 'Tiếng Thái',
    Hindi: 'Tiếng Hindi',
    Malay: 'Tiếng Malay',
    province: {
      Hebei: 'Tỉnh Hà Bắc',
      Shanxi: 'Tỉnh Sơn Tây',
      Liaoning: 'Tỉnh Liêu Ninh',
      Jilin: 'Tỉnh Cát Lâm',
      Heilongjiang: 'Tỉnh Hắc Long Giang',
      Jiangsu: 'Tỉnh Giang Tô',
      Zhejiang: 'Tỉnh Chiết Giang',
      Anhui: 'Tỉnh An Huy',
      Fujian: 'Tỉnh Phúc Kiến',
      Jiangxi: 'Tỉnh Giang Tây',
      Shandong: 'Tỉnh Sơn Đông',
      Henan: 'Tỉnh Hà Nam',
      Hubei: 'Tỉnh Hồ Bắc',
      Hunan: 'Tỉnh Hồ Nam',
      Guangdong: 'Tỉnh Quảng Đông',
      Hainan: 'Tỉnh Hải Nam',
      Sichuan: 'Tỉnh Tứ Xuyên',
      Guizhou: 'Tỉnh Quý Châu',
      Yunan: 'Tỉnh Vân Nam',
      Shaanxi: 'Tỉnh Thiểm Tây',
      Gansu: 'Tỉnh Cam Túc',
      Qinghai: 'Tỉnh Thanh Hải',
      Taiwan: 'Tỉnh Đài Loan',
      Guangxi: 'Khu tự trị dân tộc Choang Quảng Tây',
      Neimenggu: 'Khu tự trị Nội Mông Cổ',
      Tibet: 'Khu tự trị Tây Tạng',
      Ningxia: 'Khu tự trị dân tộc Hồi Ninh Hạ',
      Xinjiang: 'Khu tự trị Duy Ngô Nhĩ Tân Cương',
      HongKong: 'Khu hành chính đặc biệt Hồng Kông',
      Macau: 'Khu hành chính đặc biệt Ma Cao',
      Beijing: 'Thành phố Bắc Kinh',
      Tianjin: 'Thành phố Thiên Tân',
      Shanghai: 'Thành phố Thượng Hải',
      Chongqing: 'Thành phố Trùng Khánh',
    },
  },
  pageHeader: {
    product: 'Sản phẩm',
    tvcTest: 'Kiểm tra trải nghiệm TVC',
    tvcEval: 'Đánh giá sáng tạo TVC',
    contactUs: 'Liên hệ với chúng tôi',
    Pricing: 'Giá cả',
    Dashboard: 'Bắt đầu ngay',
    signIn: 'Đăng nhập',
    signUp: 'Đăng ký',
    resourceCenter: 'Blog',
    all: 'Tất cả',
    news: 'Tin tức',
    insight: 'Tuyển dụng',
    case: 'Trường hợp',
  },
  productSwitch: {
    common: {
      comingSoon: 'Sắp ra mắt',
    },
    modal: {
      heroTitle: 'Vui lòng chọn bài kiểm tra bạn muốn chạy',
      heroSubtitle:
        'AdEff luôn sẵn sàng cung cấp cho bạn những insight sáng tạo đa chiều bất cứ khi nào bạn cần.',
      remainingTimes: 'Số lần còn lại: {{count}}',
      supportedAssets: 'Tài sản được hỗ trợ',
      coreMetrics: 'Chỉ số cốt lõi',
      cognitiveNeuroscienceIndicators: 'Chỉ số nhận thức-thần kinh',
      consumerAttitudeIndicators: 'Chỉ số thái độ người tiêu dùng',
      outputResult: 'Kết quả đầu ra',
      dataReport: 'Báo cáo dữ liệu',
      analysisReport: 'Báo cáo phân tích',
      accessBackend: 'Bắt đầu ngay',
      tabs: {
        tvc: 'Kiểm thử sáng tạo ngang',
        portrait: 'Kiểm thử sáng tạo dọc',
      },
      cards: {
        tvcQuick: {
          title: 'Ngang-Kiểm thử nhanh',
          descriptionHighlight:
            'Đánh giá nhanh nội dung sáng tạo để thúc đẩy quyết định dựa trên dữ liệu',
        },
        tvcBase: {
          title: 'Chẩn đoán sáng tạo-ngang',
          descriptionHighlight:
            'Tinh chỉnh chi tiết sáng tạo với các đề xuất chỉnh sửa có thể triển khai',
          value1: 'Sáng tạo TVC/OTV 10–60 giây',
          value2: 'Chỉ số nhận thức-thần kinh',
        },
        tvcSurvey: {
          title: 'InsightPro-ngang',
          descriptionHighlight:
            'Phân tích sáng tạo đa chiều với định hướng tối ưu hóa chiến lược',
          value1: 'Sáng tạo TVC/OTV 10–60 giây',
          value2: 'Chỉ số nhận thức-thần kinh',
        },
        portraitQuick: {
          title: 'Dọc-Kiểm thử nhanh',
          descriptionHighlight:
            'Đánh giá nhanh nội dung sáng tạo để thúc đẩy quyết định dựa trên dữ liệu',
        },
        portraitBase: {
          title: 'Chẩn đoán sáng tạo-dọc',
          descriptionHighlight:
            'Tinh chỉnh chi tiết sáng tạo với các đề xuất chỉnh sửa có thể triển khai',
          value1: 'Sáng tạo dọc 5–90 giây',
          value2: 'Chỉ số nhận thức-thần kinh',
        },
        portraitSurvey: {
          title: 'InsightPro-dọc',
          descriptionHighlight:
            'Phân tích sáng tạo đa chiều với định hướng tối ưu hóa chiến lược',
          value1: 'Sáng tạo dọc 5–90 giây',
          value2: 'Chỉ số nhận thức-thần kinh',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'Kiểm thử sáng tạo ngang',
          assetText: 'Dành cho sáng tạo TVC/OTV 10-60 giây',
        },
        portrait: {
          bannerTitle: 'Kiểm thử sáng tạo dọc',
          assetText: 'Dành cho sáng tạo dọc 5-90 giây',
        },
      },
      items: {
        tvcQuick: {
          description: 'Nhanh chóng so sánh các ý tưởng sáng tạo và quyết định',
        },
        tvcBase: {
          title: 'Chẩn đoán sáng tạo',
          description: 'Tối ưu theo từng giây để tinh chỉnh sáng tạo',
        },
        tvcSurvey: {
          title: 'Phân tích chuyên sâu',
          description: 'Phân tích toàn diện để xác định chính xác vấn đề',
        },
        portraitBase: {
          title: 'Chẩn đoán sáng tạo',
          description: 'Tối ưu theo từng giây để tinh chỉnh sáng tạo',
        },
        portraitQuick: {
          description: 'Nhanh chóng so sánh các ý tưởng sáng tạo và quyết định',
        },
        portraitSurvey: {
          title: 'Phân tích chuyên sâu',
          description: 'Phân tích toàn diện để xác định chính xác vấn đề',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'Chúng tôi sử dụng cookie',
    desc: 'Chúng tôi sử dụng cookie cần thiết để đảm bảo trang web của chúng tôi hoạt động bình thường. Với sự đồng ý của bạn, chúng tôi cũng sử dụng cookie phân tích để cải thiện trải nghiệm của bạn. Vui lòng xem chính sách cookie của chúng tôi trong chính sách bảo mật.',
    btn1: 'Từ chối tất cả',
    btn2: 'Chấp nhận tất cả',
    cookiePolicy: 'Chính sách cookie',
  },
  landing: {
    banner: {
      text1: 'Được điều khiển bởi AI',
      text2: 'Quảng cáo',
      text3: 'Kiểm tra',
      text4: 'Nền tảng kiểm tra và tối ưu hóa sáng tạo',
      feature1: 'Giải mã nội dung',
      feature2: 'Dự đoán phản hồi',
      feature3: 'Tích hợp dữ liệu',
      feature4: 'Kết luận và khuyến nghị',
      btn1: 'Nhận bản demo',
      btn2: 'Tạo dự án',
    },
    info: {
      title:
        'Dựa trên mô hình ngôn ngữ lớn đa mô hình (HMLLM)*, nhanh chóng thực hiện dự đoán hiệu quả sáng tạo và tăng ROI quảng cáo',
      subTitle:
        '*Mô hình này dựa trên một số lượng lớn các bài kiểm tra tâm lý thần kinh và cấu trúc đa tác nhân',
      detail1: 'Kiểm tra quảng cáo nhanh chóng',
      detail1Desc:
        'AdEff có thể thu được đường cong chú ý của khán giả mục tiêu, sự dao động cảm xúc và sự tham gia vào nội dung sáng tạo trong 15 phút và cung cấp báo cáo chi tiết và hướng dẫn tối ưu hóa.',
      detail2: 'Lựa chọn sáng tạo tốt nhất nhanh chóng',
      detail2Desc:
        'AdEff hỗ trợ đo lường nhiều sáng tạo cùng một lúc, giúp các thương hiệu đưa ra quyết định nhanh chóng. Và cung cấp phân tích so sánh chi tiết.',
      detail3: 'Chỉnh sửa một lần nhấp, tạo ra các phiên bản hiệu quả đa dạng',
      detail3Desc:
        'AdEff hỗ trợ chỉnh sửa một lần nhấp, nhanh chóng tạo ra các phiên bản hiệu quả đa dạng, phù hợp với nhiều kịch bản phát hành khác nhau.',
    },
    advantages: {
      title: 'Lợi ích của AdEff',
      item1Title: 'Phản hồi nhanh chóng',
      item1Desc: 'Báo cáo nhanh nhất trong <tmp>15 phút</tmp>.',
      item2Title: 'Mô hình AI độc đáo',
      item2Desc: 'Mô hình <tmp>AI</tmp> độc đáo dựa trên phản hồi của khán giả.',
      item3Title: 'Biểu đồ trực quan',
      item3Desc:
        '<tmp>Biểu đồ trực quan</tmp> + Giải thích AI, báo cáo kiểm tra chỉ với một lần nhấp',
      item4Title: 'Phạm vi dữ liệu khổng lồ',
      item4Desc: '<tmp>50,000+</tmp> cơ sở dữ liệu sáng tạo',
      item5Title: 'Đội ngũ chuyên gia',
      item5Desc: '<tmp>Đội ngũ chuyên gia</tmp> cung cấp hỗ trợ và khuyến nghị',
    },
    service: {
      title: 'Các phương thức dịch vụ của AdEff',
      desc: 'Chọn phương thức dịch vụ bạn cần',
      topTitle: 'Dịch vụ tự phục vụ trực tuyến',
      topRow1: 'Tự tạo dự án và hoàn thành kiểm tra',
      topRow2: 'Biểu đồ trực quan + Giải thích báo cáo AI',
      topRow3: 'Phân tích khách quan các chỉ số thần kinh (chuyển động mắt + EEG)',
      topRow4: 'Kiểm tra mô hình AI độc đáo',
      bottomTitle: 'Dịch vụ của đội ngũ chuyên gia',
      bottomRow1: 'Tạo dự án và hoàn thành kiểm tra bởi các chuyên gia',
      bottomRow2:
        'Phân tích khách quan các chỉ số thần kinh (chuyển động mắt + EEG), có thể thêm các chỉ số chủ quan',
      bottomRow3: 'Biểu đồ trực quan + Giải thích báo cáo của chuyên gia',
      bottomRow4: 'Kiểm tra mô hình AI độc đáo, có thể kiểm tra mẫu thực tế',
    },
    footer: {
      title:
        'AdEff dựa trên mô hình ngôn ngữ lớn đa mô hình (HMLLM), xây dựng các mối quan hệ phức tạp giữa các yếu tố hình ảnh và tín hiệu EEG cũng như dữ liệu theo dõi mắt để kiểm tra nhanh chóng các sáng tạo quảng cáo',
      email: 'Email',
      belongDesc: 'Sản phẩm của <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'Bắt đầu ngay',
  },
  contact: {
    title: 'Liên hệ với chúng tôi',
    copy: 'Sao chép',
    message: { success: 'Sao chép thành công' },
  },
  pricing: {
    title: 'Chuyên gia kiểm tra và tối ưu hóa sáng tạo dựa trên AI',
    starter: {
      title: 'Khởi đầu',
      desc_1: 'Phù hợp cho các bài kiểm tra một lần sử dụng, sẵn sàng sử dụng ngay khi mua',
      desc_2: 'Phù hợp cho các bài kiểm tra quy mô nhỏ, sẵn sàng sử dụng ngay khi mua',
      timesDesc: '<strong>{{count}}</strong> lần cho bất kỳ loại kiểm tra quảng cáo nào',
      timesDesc1: '<strong>{{count}}</strong> lần cho bất kỳ loại kiểm tra quảng cáo nào',
      discount: 'Giảm 50%',
      originPrice: 'Giá',
      desc2: 'Mô hình ngôn ngữ lớn đa mô hình dựa trên phản hồi của khán giả',
      desc3: 'Phản hồi nhanh chóng, tạo báo cáo nhanh nhất trong 15 phút',
      desc4: 'Biểu đồ trực quan phong phú',
      desc5: 'Giải thích AI thông minh chuyên nghiệp',
      desc6: 'Cơ sở dữ liệu và tiêu chuẩn toàn cầu',
      cardDesc1: 'Ưu đãi có thời hạn, chỉ từ {{pricePerTest}}',
      cardDesc2: 'Hạn mức kiểm tra không bao giờ hết hạn',
    },
    premium: {
      time: 'lần',
    },
    unlimited: {
      title: 'Không giới hạn',
      cardDesc1: 'Chỉ từ {{pricePerTest}}',
      cardDesc2: 'Hạn mức có hiệu lực trong một năm',
      cardDesc3: 'Benchmark độc quyền tùy chỉnh',
      planDesc500: 'Tận hưởng 500 lượt kiểm tra trong cả năm',
      planDesc1000: 'Tận hưởng 1.000 lượt kiểm tra trong cả năm',
    },
    benefits: {
      title: 'Vì sao chọn AdEff?',
      subtitle: 'Với AdEff, bạn sẽ nhận được các lợi ích sau:',
      expertSupport: 'Đội ngũ chuyên gia hỗ trợ và tư vấn',
      moreNeedsTitle: 'Bạn có nhu cầu mua khác không?',
      customPlanPrefix: 'Chúng tôi hỗ trợ các gói linh hoạt và tùy chỉnh — liên hệ tại',
      customPlanSuffix: 'để nhận giải pháp riêng cho bạn',
    },
    subscribeBtn: 'Đăng ký ngay',
    contactUs: 'Liên hệ với chúng tôi',
  },
  login: {
    loginText: 'Đăng nhập',
    signUpText: '<tmp>Đăng ký</tmp> miễn phí',
    text1: 'Tham gia nhóm',
    text1Desc:
      'AdEff dựa trên mô hình ngôn ngữ lớn đa mô hình (HMLLM), xây dựng các mối quan hệ phức tạp giữa các yếu tố hình ảnh và tín hiệu EEG cũng như dữ liệu theo dõi mắt để kiểm tra nhanh chóng các sáng tạo quảng cáo',
    text2: 'Người dùng đã tham gia công ty',
    text3: 'Liên kết mời nhóm đã hết hạn',
    text4: 'Liên kết mời nhóm không còn hợp lệ.',
    optionText1: 'Bạn đã có tài khoản?',
    optionText2: 'Chưa có tài khoản?',
    alertText1: 'Bằng cách đăng ký, tôi đồng ý với',
    alertText2: 'Tôi đồng ý với',
    termsOfService: 'Điều khoản dịch vụ',
    privacy: 'Chính sách bảo mật',
    privacyTips: 'Vui lòng kiểm tra hộp đồng ý trước khi đăng ký.',
    and: 'và',
    or: 'hoặc',
    next: 'Tiếp theo',
    googleLogin: 'Đăng nhập bằng Google',
    googleSignUp: 'Đăng ký bằng Google',
    loginWithEmail: 'Đăng nhập bằng email',
    signUpWithEmail: 'Đăng ký bằng email',
    password: 'Mật khẩu',
    emailAddress: 'Địa chỉ email',
    enterEmail: 'Nhập địa chỉ email của bạn',
    enterPassword: 'Nhập mật khẩu của bạn',
    confirmPassword: 'Xác nhận mật khẩu',
    forgotPassword: 'Quên mật khẩu?',
    inconsistentPassword: 'Mật khẩu không khớp',
    verificationCode: 'Mã xác minh',
    emptyVerificationCode: 'Mã xác minh không thể để trống',
    enterVerificationCode: 'Nhập mã xác minh',
    sendedVerificationCode: 'Mã xác minh đã được gửi đến email của bạn',
    emailOrPasswordNotCorrect: 'Email hoặc mật khẩu không chính xác.',
    message: {
      text1: 'Nhập không hợp lệ',
      text2: 'Email đã được đăng ký',
      text3: 'Lỗi xác minh mã xác minh!',
      text4: 'Tài khoản này không liên kết với công ty, vui lòng liên kết lại!',
      text5: 'Vui lòng nhập định dạng email chính xác',
      text6: 'Mật khẩu phải có ít nhất 12 ký tự',
      text7: 'Mật khẩu phải chứa chữ cái in hoa, chữ cái thường và số',
      requestLimit: 'Yêu cầu vượt quá giới hạn, vui lòng thử lại sau',
    },
  },
  resetPwdPage: {
    submit: 'Gửi',
    emailNotFound: 'Vui lòng kiểm tra email của bạn',
    emailHasSent: 'Email đã được gửi đến {{email}}',
    checkYourInbox: 'Kiểm tra hộp thư đến của bạn',
    resetYourPassword: 'Đặt lại mật khẩu của bạn',
    resetLinkHasSent:
      'Một email với liên kết để đặt lại mật khẩu đã được gửi đến email được liên kết với tài khoản của bạn',
    enterYourEmailAddress:
      'Nhập địa chỉ email của bạn và chúng tôi sẽ gửi cho bạn một liên kết để đặt lại mật khẩu',
    didNotGetEmail: 'Không nhận được email?',
    tryAgain: 'Thử lại',
    goBackToSign: 'Quay lại đăng ký',
    email: 'Email',
    enterYourEmail: 'Nhập địa chỉ email của bạn',
    resetPassword: 'Đặt lại mật khẩu',
    resetPwdSuccess: 'Mật khẩu đã được đặt lại thành công',
    message: {
      resetLinkCodeError: 'Mã liên kết không hợp lệ',
      requestLimit: 'Yêu cầu vượt quá giới hạn, vui lòng thử lại sau',
    },
  },
  memberRequestPage: {
    title: 'Xác minh yêu cầu thành viên',
    subTitle: 'Yêu cầu từ:',
    deny: 'Từ chối',
    approve: 'Chấp thuận',
    teamFull: 'Nhóm đã đầy',
    yourTeamIsFull:
      'Nhóm của bạn đã đầy. Bạn có thể liên hệ với chúng tôi để có thêm thành viên hoặc xóa các thành viên khác.',
    manageMembers: 'Quản lý thành viên trong AdEff',
    requestApproved: 'Yêu cầu đã được chấp thuận',
    approvedDesc:
      'Bạn đã chấp thuận <tmp>{{name}}</tmp> tham gia nhóm của bạn, thông báo đã được gửi tự động.',
    requestDeclined: 'Yêu cầu đã bị từ chối',
    declinedDesc:
      'Bạn đã từ chối <tmp>{{name}}</tmp> tham gia nhóm của bạn, thông báo đã được gửi tự động.',
  },
  infoBindPage: {
    title: 'Kiểm tra quảng cáo được hỗ trợ bởi AI',
    desc: 'Dựa trên mô hình ngôn ngữ lớn đa mô hình (HMLLM)*, nhanh chóng thực hiện dự đoán hiệu quả sáng tạo và tăng ROI quảng cáo',
    joinAdEff: 'Tham gia AdEff và bắt đầu hành trình mới',
    advantages: {
      title1: 'Mạnh mẽ hơn',
      desc1: 'Mô hình AI độc đáo dựa trên cơ sở dữ liệu lớn',
      title2: 'Kinh tế hơn',
      desc2: 'Chỉ với 10% giá của các phương pháp truyền thống',
      title3: 'Nhanh hơn',
      desc3: 'Báo cáo nhanh nhất trong 15 phút',
      title4: 'Chuyên nghiệp hơn',
      desc4: 'Hỗ trợ dịch vụ 24/7 và dịch vụ của đội ngũ chuyên gia',
    },
    username: 'Tên người dùng',
    company: 'Công ty',
    placeOfResidence: 'Quốc gia/Khu vực',
    invitationCode: 'Mã giới thiệu',
    createAccountForFree: 'Tạo tài khoản miễn phí',
    refreshStatus: 'Làm mới trạng thái',
    reapply: 'Nộp lại',
    bySigningUp: 'Bằng cách đăng ký, tôi đồng ý với',
    termsOfService: 'Điều khoản dịch vụ',
    and: 'và',
    privacyPolicy: 'Chính sách bảo mật',
    message: {
      success: 'Yêu cầu tạo tài khoản đã được gửi, vui lòng chờ đợi!',
      success2: 'Tài khoản đã được tạo thành công',
      error: 'Không thể tạo tài khoản, vui lòng thử lại sau.',
      accountCreatedDirectly: 'Tài khoản của bạn đã được tạo trực tiếp!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'Yêu cầu đã được chấp thuận, trang sẽ tự động chuyển hướng.',
      theRequestHasBeenSendAndPleaseBePatient: 'Yêu cầu đã được gửi, vui lòng chờ đợi!',
      wrongRouting: 'Lỗi định tuyến, trang sẽ tự động chuyển hướng.',
      yourRequestHasBeenDeclined:
        'Yêu cầu của bạn đã bị từ chối. Bạn có thể nộp lại yêu cầu tham gia nhóm hoặc tạo một tài khoản mới mà không cần mã mời.',
      waitingForAdministratorReview: 'Chờ xem xét của quản trị viên',
      thisFieldIsRequired: 'Trường này là bắt buộc',
      pleaseEnterTheResidence: 'Vui lòng nhập quốc gia',
      invitationCodeDoesNotExist: 'Mã giới thiệu không hợp lệ',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'Nếu bạn đang sử dụng thông qua giới thiệu của đại lý, vui lòng nhập mã giới thiệu',
      pleaseEnterTheUsername: 'Vui lòng nhập tên người dùng',
      pleaseEnterTheCompanyName: 'Vui lòng nhập tên công ty',
      needRegisterAgain: 'Lỗi trong quá trình thao tác, vui lòng đăng ký lại',
      alreadyBind: 'Bạn đã liên kết công ty, vui lòng liên kết lại',
    },
  },
  knowledgeFormPage: {
    name: 'Tên của bạn',
    email: 'Email của bạn',
    companyName: 'Tên công ty',
    department: 'Phòng ban',
    role: 'Chức vụ',
    country: 'Quốc gia',
    province: 'Tỉnh/Thành phố',
    pleaseEnter: 'Vui lòng nhập',
    pleaseSelect: 'Vui lòng chọn',
    pleaseEnterTheName: 'Vui lòng nhập tên của bạn',
    pleaseEnterTheEmail: 'Vui lòng nhập email của bạn',
    pleaseEnterValidEmail: 'Vui lòng nhập email hợp lệ',
    pleaseEnterTheCompanyName: 'Vui lòng nhập tên công ty của bạn',
    pleaseSelectTheDepartment: 'Vui lòng chọn phòng ban của bạn',
    pleaseSelectTheRole: 'Vui lòng chọn chức vụ của bạn',
    pleaseSelectTheCountry: 'Vui lòng chọn quốc gia của bạn',
    pleaseSelectTheProvince: 'Vui lòng chọn tỉnh/thành phố của bạn',
    textIsRequired: 'Trường này là bắt buộc',
    submit: 'Gửi',
    download: 'Tải xuống',
    submitSuccess: 'Gửi thành công',
    downloadSuccess: 'Tải xuống thành công',
    title1: 'Vui lòng điền thông tin của bạn để nhận tài nguyên',
    title2: 'Vui lòng chọn tài nguyên bạn muốn tải xuống',
  },
  dashboard: {
    pdf: {
      downloadReport: 'Tải xuống báo cáo',
      downloadBtnText: 'Tải xuống PDF',
      content: 'Nội dung',
      theEnd: 'Kết thúc',
      thankYouForWatching: 'Cảm ơn bạn đã xem.',
      pdfProcessing: 'Đang xử lý PDF...',
      pdfProcessingDesc:
        'PDF trang: {{count}}，dự kiến {{seconds}} giây，lưu sau đó，vui lòng chờ đợi',
      pdfProcessingDesc2: 'Ngôn ngữ hiện tại chưa được dịch, không thể tạo PDF',
    },
    ppt: {
      downloadBtnText: 'Tải xuống PPT',
      pptProcessingDesc: 'Đang tạo tệp PPT, vui lòng đợi',
      pptProcessingDesc2: 'Phiên bản ngôn ngữ hiện tại chưa được dịch, không thể tạo PPT',
      pptProcessingDesc3: 'Đang tải xuống tệp PPT, vui lòng chờ...',
      translateCompleted: 'Dịch PPT hoàn tất',
      exportSuccess: 'Xuất tệp PPT thành công',
      exportFailed: 'Xuất tệp PPT thất bại',
    },
    layout: {
      projectMenuText: 'Dự án kiểm tra quảng cáo',
      accountManagementText: 'Quản lý tài khoản',
      myAccountText: 'Tài khoản của tôi',
      subscriptionText: 'Đăng ký',
      logout: 'Đăng xuất',
      dataDetails: 'Chi tiết dữ liệu',
      dataAnalysis: 'Phân tích dữ liệu',
      dataOverview: 'Tổng quan dữ liệu',
      dataComparison: 'So sánh dữ liệu',
    },
    systemMessage: {
      title: 'Thông báo hệ thống',
      task: 'Nhiệm vụ',
      system: 'Hệ thống',
      noRelevantContent: 'Không tìm thấy nội dung liên quan',
      noMore: 'Không còn tin nhắn nào',
    },
    projectPage: {
      createProject: 'Tạo dự án',
      searchPlaceholder: 'Nhập tên dự án/quảng cáo/thương hiệu để tìm kiếm',
      sortLabel: 'Sắp xếp theo chỉ số hiệu quả quảng cáo',
      sortPlaceholder: 'Chọn phương pháp sắp xếp',
      sortOption1: 'Tăng dần theo chỉ số hiệu quả',
      sortOption2: 'Giảm dần theo chỉ số hiệu quả',
      filterSort: 'Lọc và sắp xếp',
      filterBenchmarkTitle: 'Lọc chuẩn tham chiếu',
      sortTitle: 'Sắp xếp',
      tabAllCreative: 'Tất cả sáng tạo ({{count}})',
      tabGeneralCreative: 'Sáng tạo thường ({{count}})',
      tabSplashCreative: 'Sáng tạo mở màn ({{count}})',
      generalCreativeLabel: 'Sáng tạo thường',
      splashCreativeLabel: 'Sáng tạo mở màn',
      normTypePlaceholder: 'Vui lòng chọn loại chuẩn',
      totalDesc: 'Dự án quảng cáo (tổng {{total}})',
      noRelevantContent: 'Không tìm thấy nội dung liên quan',
      loadMore: 'Tải thêm',
      projectCard: { delete: 'Xóa', reanalyze: 'Phân tích lại', download: 'Tải xuống' },
      delete: 'Xóa',
      cancel: 'Hủy',
      message: {
        deleteTitle: 'Cảnh báo xóa',
        delete:
          'Khi bạn xóa dự án này, tất cả dữ liệu liên quan sẽ không còn khả dụng. Bạn có chắc chắn muốn tiếp tục xóa không?',
        delete1: 'Dự án này là dự án kiểm tra miễn phí, và việc xóa sẽ không thể hoàn tác.',
        delete2:
          'Dự án này chưa bắt đầu phân tích. Sau khi xóa, số lần kiểm tra của bạn sẽ được hoàn trả',
        deleteSuccess: 'Xóa thành công!',
        analysisCountNotEnough: 'Số lần phân tích không đủ, vui lòng nạp tiền để tiếp tục.',
        analysisFailed: 'Phân tích thất bại, vui lòng thử lại sau.',
        waitingQuestion:
          'Tối đa có thể phân tích đồng thời 3 dự án. Dự án này đã vào hàng đợi và sẽ tự động bắt đầu phân tích sau.',
        landscapeQuickCompleted: 'Dự án kiểm thử nhanh ngang của bạn đã hoàn tất.',
        portraitQuickCompleted: 'Dự án kiểm thử nhanh dọc của bạn đã hoàn tất.',
        landscapeSurveyCompleted: 'Dự án insight chuyên sâu ngang của bạn đã hoàn tất.',
        portraitSurveyCompleted: 'Dự án insight chuyên sâu dọc của bạn đã hoàn tất.',
      },
    },
    projectCreatePage: {
      createProject: 'Tạo dự án',
      basicInformation: 'Thông tin cơ bản',
      projectType: 'Loại dự án',
      projectName: 'Tên dự án',
      categoryType: 'Ngành',
      brandName: 'Tên thương hiệu',
      advertisingInformation: 'Thông tin quảng cáo',
      adName: 'Tên quảng cáo',
      norm: 'Giá trị chuẩn',
      targetMarketNorm: 'Giá trị chuẩn thị trường mục tiêu',
      brandNorm: 'Giá trị chuẩn thương hiệu',
      taGender: 'Giới tính của TA',
      targetMarket: 'Thị trường mục tiêu',
      taAge: 'Tuổi của TA',
      next: 'Tiếp theo',
      previous: 'Trước',
      confirmOrder: 'Xác nhận đơn hàng',
      estTime: 'Thời gian ước tính',
      minutes: 'phút',
      consumption: 'Tiêu thụ cho đơn hàng này',
      testPoint: 'Số lần kiểm tra',
      remaining: 'Còn lại',
      times: 'lần',
      type: 'Loại',
      purchase: 'Mua hàng',
      outputLanguage: 'Ngôn ngữ xuất ra',
      durationCategory: 'Loại sáng tạo',
      durationCategoryDesc: 'Các chỉ số phân tích thay đổi theo loại sáng tạo, vui lòng chọn tùy chọn phù hợp nhất với nội dung của bạn.',
      durationCategoryOptions: {
        tenPlus: 'Sáng tạo thông thường (10s+)',
        fiveToTen: 'Sáng tạo mở đầu (5-10s)',
      },
      adSelection: {
        adCreativeTest: 'Kiểm tra sáng tạo quảng cáo',
        adCreativeTestDesc:
          'Kiểm tra phản hồi của khán giả đối với một sáng tạo quảng cáo, cung cấp phân tích và khuyến nghị',
        adCreativeSelection: 'Lựa chọn sáng tạo quảng cáo',
        adCreativeSelectionDesc: 'So sánh phản hồi của nhiều sáng tạo quảng cáo, lựa chọn tổng hợp',
        adCreativeEditing: 'Chỉnh sửa sáng tạo quảng cáo',
        adCreativeEditingDesc:
          'AI thông minh lọc ra những phần tinh túy trong sáng tạo quảng cáo, tự động tạo ra sáng tạo quảng cáo',
        launchingSoon: 'Sắp ra mắt',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'Ngành thực phẩm và đồ uống',
        packagedFood: 'Thực phẩm đóng gói',
        confectionery: 'Đồ ăn và đồ uống',
        frozenMeals: 'Thực phẩm đông lạnh',
        fastFood: 'Đồ ăn nhanh',
        beverage: 'Đồ uống',
        alcohol: 'Rượu',
        dairy: 'Sữa',
        grainAndSeasoning: 'Gạo và gia vị',
        beverageMixes: 'Nước uống và đồ uống',
        freshProduce: 'Thực phẩm tươi',
        otherFoodAndBeverage: 'Ngành khác',
        /**----------------------- */
        consumerElectronicsCategory: 'Ngành điện tử tiêu dùng',
        mobilePhone: 'Điện thoại di động',
        computer: 'Máy tính',
        smartDevice: 'Thiết bị thông minh',
        phoneAccessories: 'Phụ kiện điện thoại',
        computerAccessories: 'Phụ kiện máy tính',
        software: 'Phần mềm',
        camera: 'Máy ảnh',
        officeSupplies: 'Văn phòng phẩm',
        otherConsumerElectronics: 'Ngành khác',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'Ngành y tế',
        otcMedicine: 'Thuốc không cần đơn',
        prescriptionDrugs: 'Thuốc cần đơn',
        healthSupplements: 'Supplement dinh dưỡng',
        pharmaceuticalCompanies: 'Công ty dược phẩm',
        medicalDevices: 'Thiết bị y tế',
        medicalServices: 'Dịch vụ y tế',
        pharmacy: 'Nhà thuốc',
        otherPharmaceuticalsAndHealthCare: 'Ngành khác',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'Ngành làm đẹp và chăm sóc cá nhân',
        hairCare: 'Chăm sóc tóc',
        womenSkincare: 'Chăm sóc da nữ',
        homeCleaning: 'Vệ sinh nhà cửa',
        bodyCare: 'Chăm sóc thân thể',
        feminineCare: 'Chăm sóc nữ tính',
        oralCare: 'Chăm sóc miệng',
        menSkincare: 'Chăm sóc da nam',
        makeup: 'Trang điểm',
        fragrances: 'Nước hoa',
        beautyServices: 'Dịch vụ làm đẹp',
        otherBeautyAndPersonalCare: 'Ngành khác',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'Ngành sản phẩm mẹ và trẻ em',
        babyFood: 'Thực phẩm cho trẻ em',
        babyCareEssentials: 'Vật dụng chăm sóc trẻ em',
        babyToys: 'Đồ chơi cho trẻ em',
        otherMaternalAndInfantProducts: 'Ngành khác',
        /**----------------------- */
        networkAndCommunicationCategory: 'Ngành viễn thông',
        mobileCarriers: 'Nhà cung cấp dịch vụ di động',
        internetProviders: 'Nhà cung cấp dịch vụ internet',
        telecomEquipment: 'Thiết bị viễn thông',
        otherNetworkAndCommunication: 'Ngành khác',
        /**----------------------- */
        travelAndAccommodationCategory: 'Ngành du lịch và lưu trú',
        localTourism: 'Du lịch địa phương',
        bookingPlatform: 'Nền tảng đặt phòng',
        hotels: 'Khách sạn',
        airlines: 'Hãng hàng không',
        airport: 'Sân bay',
        otherTravelAndAccommodation: 'Ngành khác',
        /**----------------------- */
        vehiclesCategory: 'Ngành phương tiện',
        motorVehicleProductsAndServices: 'Phương tiện giao thông',
        carBrands: 'Thương hiệu xe hơi',
        dealerships: 'Đại lý xe hơi',
        carFinance: 'Tài chính xe hơi',
        evCar: 'Xe điện',
        motorcycle: 'Xe máy',
        onlineUsedCarMarketplace: 'Thị trường xe hơi đã qua sử dụng trực tuyến',
        carRentalPlatform: 'Nền tảng thuê xe hơi',
        travelNavigation: 'Điều hướng du lịch',
        bicycle: 'Xe đạp',
        otherVehicles: 'Phương tiện khác',
        /**----------------------- */
        householdAppliancesCategory: 'Ngành điện tử gia dụng',
        majorAppliances: 'Đồ gia dụng lớn',
        healthAndPersonalCareAppliances: 'Điện gia dụng cá nhân',
        majorKitchenAndBathAppliances: 'Điện gia dụng lớn',
        smallKitchenAppliances: 'Điện gia dụng nhỏ',
        environmentalAppliances: 'Điện gia dụng môi trường',
        cleaningAppliances: 'Điện gia dụng vệ sinh',
        otherHouseholdAppliances: 'Điện gia dụng khác',
        /**----------------------- */
        retailAndServiceCategory: 'Ngành thương mại và dịch vụ',
        onlineRetailEcommerce: 'Thương mại điện tử',
        departmentStores: 'Cửa hàng bách hóa',
        lifeServices: 'Dịch vụ sinh hoạt',
        retailServicesAndDelivery: 'Dịch vụ thương mại/Giao hàng',
        supermarkets: 'Siêu thị',
        otherRetailAndService: 'Ngành khác',
        /**----------------------- */
        apparelCategory: 'Ngành vải',
        footwear: 'Giày dép',
        clothing: 'Quần áo',
        watchesWatchRetail: 'Đồng hồ/cửa hàng đồng hồ',
        jewelry: 'Trang sức',
        bags: 'Túi xách',
        eyewearOpticalStores: 'Kính/cửa hàng kính',
        otherClothingAndAccessories: 'Ngành khác',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'Ngành nội thất và trang trí',
        homeFurnishing: 'Nội thất',
        homeImprovement: 'Trang trí',
        otherHomeImprovementAndFurnishings: 'Ngành khác',
        /**----------------------- */
        financialAndInsuranceCategory: 'Ngành tài chính và bảo hiểm',
        bank: 'Ngân hàng',
        fintech: 'Ngân hàng số',
        investmentAndFinancialServices: 'Dịch vụ tài chính',
        insurance: 'Bảo hiểm',
        otherFinancialAndInsurance: 'Ngành khác',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'Ngành giải trí và vui chơi',
        socialApp: 'Ứng dụng xã hội',
        toysAndDolls: 'Đồ chơi và búp bê',
        concerts: 'Buổi hòa nhạc',
        events: 'Sự kiện',
        movies: 'Phim ảnh',
        themeParks: 'Công viên thể thao',
        gambling: 'Trò chơi cá cược',
        onlineGaming: 'Trò chơi trực tuyến',
        tvChannels: 'Kênh truyền hình',
        otherEntertainmentAndLeisure: 'Ngành khác',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'Ngành công nghiệp và nông nghiệp',
        industrialSupplies: 'Vật tư công nghiệp',
        agriculturalSupplies: 'Vật tư nông nghiệp',
        otherIndustrialAndAgricultural: 'Ngành khác',
        /**----------------------- */
        petLifeCategory: 'Ngành thú cưng',
        petFood: 'Thức ăn thú cưng',
        petSupplies: 'Vật dụng thú cưng',
        otherPetLife: 'Ngành khác',
        /**----------------------- */
        educationAndLearningCategory: 'Ngành giáo dục và học tập',
        onlineLearning: 'Học trực tuyến',
        schools: 'Trường học',
        skillCourses: 'Khóa học kỹ năng',
        tutoring: 'Học viên',
        universities: 'Trường đại học',
        otherEducationAndLearning: 'Ngành khác',
        /**----------------------- */
        communityAndPublicServiceCategory: 'Ngành cộng đồng và dịch vụ công cộng',
        charityCampaigns: 'Chiến dịch từ thiện',
        ngoAds: 'Quảng cáo từ thiện',
        otherCommunityAndPublicService: 'Ngành khác',
        /**----------------------- */
        otherCategory: 'Ngành khác',
        governmentAdvertising: 'Quảng cáo chính phủ',
        realEstateAdvertising: 'Quảng cáo bất động sản',
        otherAdvertising: 'Quảng cáo khác',
      },
      genderSelect: {
        male: 'Nam',
        female: 'Nữ',
        all: 'Tất cả',
      },
      targetMarketSelect: {
        China: 'Trung Quốc',
        HongKongChina: 'Hồng Kông, Trung Quốc',
        MacauChina: 'Ma Cao, Trung Quốc',
        TaiwanChina: 'Đài Loan, Trung Quốc',
        Japan: 'Nhật Bản',
        Korea: 'Hàn Quốc',
        Mongolia: 'Mông Cổ',
        Singapore: 'Singapore',
        Thailand: 'Thái Lan',
        Vietnam: 'Việt Nam',
        Malaysia: 'Malaysia',
        Philippines: 'Philippines',
        Indonesia: 'Indonesia',
        Cambodia: 'Campuchia',
        Laos: 'Lào',
        India: 'Ấn Độ',
        SaudiArabia: 'Ả Rập Xê Út',
        Turkey: 'Thổ Nhĩ Kỳ',
        Israel: 'Israel',
        UnitedArabEmirates: 'Các Tiểu vương quốc Ả Rập Thống nhất',
        Qatar: 'Qatar',
        Kuwait: 'Kuwait',
        UnitedKingdom: 'Vương quốc Anh',
        France: 'Pháp',
        Germany: 'Đức',
        Netherlands: 'Hà Lan',
        Belgium: 'Bỉ',
        Austria: 'Áo',
        Italy: 'Ý',
        Spain: 'Tây Ban Nha',
        Portugal: 'Bồ Đào Nha',
        Greece: 'Hy Lạp',
        Sweden: 'Thụy Điển',
        Norway: 'Na Uy',
        Finland: 'Phần Lan',
        Denmark: 'Đan Mạch',
        Estonia: 'Estonia',
        Latvia: 'Latvia',
        Russia: 'Nga',
        Poland: 'Ba Lan',
        CzechRepublic: 'Cộng hòa Séc',
        Hungary: 'Hungary',
        Romania: 'Rumani',
        Bulgaria: 'Bulgaria',
        Slovakia: 'Slovakia',
        Slovenia: 'Slovenia',
        Ukraine: 'Ukraina',
        UnitedStates: 'Hoa Kỳ',
        Canada: 'Canada',
        Mexico: 'Mexico',
        Brazil: 'Brazil',
        LatinAmerica: 'Mỹ Latinh',
        Australia: 'Úc',
        NewZealand: 'New Zealand',
        Other: 'Khác',
      },
      languageSelect: {
        english: 'Tiếng Anh',
        chinese: 'Tiếng Trung',
        japanese: 'Tiếng Nhật',
        korean: 'Tiếng Hàn',
        french: 'Tiếng Pháp',
        traditionalChinese: 'Tiếng Trung truyền thống',
      },
      placeholder: {
        projectName: 'Nhập tên dự án',
        category: 'Chọn danh mục',
        brandName: 'Nhập tên thương hiệu',
        adName: 'Nhập tên quảng cáo',
        norm: 'Vui lòng chọn giá trị chuẩn',
        taGender: 'Chọn giới tính',
        targetMarket: 'Chọn thị trường mục tiêu',
        taAge: 'Chọn độ tuổi',
        lowerLimit: 'Giới hạn dưới',
        upperLimit: 'Giới hạn trên',
        outputLanguage: 'Chọn ngôn ngữ xuất ra',
      },
      step: {
        step1: 'Nhập thông tin dự án',
        step2: 'Xác nhận thông tin đơn hàng',
      },
      message: {
        success: 'Tạo thành công',
        videoDurationOver60s: 'Thời gian video vượt quá {{max}} giây',
        videoDurationLessThan10s: 'Thời gian video ít hơn {{min}} giây',
        videoDurationNeedOver10s: 'Thời lượng video phải lớn hơn 10 giây',
        videoDurationNeedWithin5To10s: 'Thời lượng video phải trong khoảng 5 giây đến 10 giây',
        videoDurationNotMatchDurationCategory: 'Thời lượng video hiện tại không phù hợp với loại dự án này. Vui lòng tải lại video và thử lại.',
        videoUploadingCannotSwitchDurationCategory: 'Không thể chuyển loại sáng tạo trong khi video đang tải lên. Vui lòng chờ tải lên hoàn tất.',
        videoFormatOrDurationError: 'Không thể đọc định dạng hoặc thời lượng video. Vui lòng kiểm tra tệp video rồi thử lại.',
        videoSizeOver200M: 'Kích thước video vượt quá 256MB',
        videoLandscape: 'Video phải ở định dạng video ngang',
        videoPortrait: 'Video cần ở định dạng dọc',
        clickToUploadTestVideo: 'Nhấp để tải lên video thử nghiệm',
        uploadFailed: 'Tải lên không thành công, vui lòng thử lại',
        uploadDesc1: 'Hỗ trợ các tệp video màn hình ngang ở định dạng MP4, MOV',
        uploadDescPortrait: 'Hỗ trợ tệp video dọc ở định dạng MP4, MOV',
        uploadDesc2: 'Giới hạn kích thước tệp là 256MB',
        formNotCompleted: 'Vui lòng điền đầy đủ thông tin',
        uploadAdVideo: 'Vui lòng tải lên video quảng cáo',
        inputInvalid: 'Nhập không hợp lệ',
        insufficientTestPoints: 'Điểm kiểm tra hiện tại không đủ, vui lòng nạp tiền và thử lại.',
        reviewProjectInfo:
          'Vui lòng kiểm tra kỹ thông tin dự án của bạn. Sau khi xác nhận đơn hàng, không thể thay đổi.',
        waitingDesc:
          'Tối đa có thể phân tích đồng thời 3 dự án. Dự án này đã vào hàng đợi và sẽ tự động bắt đầu phân tích sau.',
        ageRangeInvalid: 'Phạm vi tuổi chỉ được hỗ trợ từ 20 đến 55',
        normDesc:
          'Chuẩn ngành hoặc dữ liệu lịch sử, được sử dụng để so sánh hiệu suất quảng cáo theo chiều ngang.',
      },
    },
    projectDetailPage: {
      testResults: 'Kết quả kiểm tra',
      share: 'Chia sẻ',
      shareFailed: 'Chia sẻ thất bại',
      shareModal: {
        title: 'Chia sẻ',
        desc: 'Sao chép đoạn văn bản bên dưới và chia sẻ lên mạng xã hội.',
        saveImage: 'Lưu hình ảnh',
        copyText: 'Sao chép văn bản',
        copySuccess: 'Đã sao chép',
        copyFailed: 'Sao chép thất bại',
        textTemplate:
          'Wow! Sáng tạo AI của tôi đã vượt qua {{score}}% tác phẩm tương tự trên AdEff! Dữ liệu mới là thước đo thực sự! AdEff AI Creative Testing hiện đang miễn phí. Kiểm tra điểm của bạn tại {{hostname}}. Nhận 5 lượt kiểm tra miễn phí, chúc bạn nhận được nhiều đánh giá xuất sắc!',
      },
      sharePoster: {
        createdByYou: 'Do bạn sáng tạo',
        scoreTemplate: 'Vượt qua <score>{{score}}</score> các sáng tạo AIGC',
        statsAt: 'Thống kê lúc ',
        certification: 'Chứng nhận Sáng tạo',
        footerText: 'Mong bạn tiếp tục sáng tạo và mang đến thêm nhiều tác phẩm chất lượng!',
      },
      basicInformation: 'Thông tin cơ bản',
      waiting: 'Đang chờ',
      ongoing: 'Đang tiến hành',
      failed: 'Thất bại',
      tryAgain: 'Thử lại',
      videoAnalysisFailed: 'Phân tích video thất bại',
      message: { projectNotFound: 'Không tìm thấy dự án' },
      primaryAnalysis: 'Phân tích chính',
      detailAnalysis: 'Phân tích theo thời điểm',
      heatmapAnalysis: 'Bản đồ nhiệt',
      analysisStepDesc:
        'AI đã hoàn thành tất cả các nhiệm vụ phân tích, phân tích chi tiết bên dưới',
      analysisWaitingDesc:
        'Tối đa có thể phân tích đồng thời 3 dự án. Dự án này đã vào hàng đợi và sẽ tự động bắt đầu phân tích sau',
      aiTip: 'Nội dung báo cáo được tạo bởi AI và chỉ được cung cấp cho mục đích tham khảo',
      subAnalysisDescription: {
        adVideoScore: 'Chỉ số hiệu quả quảng cáo',
        adVideoScoreDesc:
          'Chỉ số hiệu quả quảng cáo là chỉ số tổng hợp đánh giá hiệu quả của quảng cáo, có khả năng dự đoán tác động ngắn hạn và dài hạn của quảng cáo.',
        norm: 'Giá trị chuẩn',
        normDesc:
          'Giá trị chuẩn cho ngành hoặc dữ liệu lịch sử, được sử dụng để so sánh hiệu suất quảng cáo theo chiều ngang.',
        attentionIndex: 'Chỉ số chú ý',
        attentionIndexDesc:
          'Mức độ tập trung chú ý của khán giả, phản ánh khả năng của hình ảnh quảng cáo thu hút sự chú ý.',
        emotionIndex: 'Chỉ số cảm xúc',
        emotionIndexDesc:
          'Mức độ cảm xúc tích cực của khán giả được kích thích, phản ánh sự dao động cảm xúc tức thì do quảng cáo gây ra.',
        cognitionIndex: 'Chỉ số nhận thức',
        cognitionIndexDesc:
          'Phản ánh mức độ xử lý nhận thức của khán giả, tức là mức độ họ đã suy nghĩ về nội dung quảng cáo.',
        theGolden3Seconds: '3 giây vàng',
        theGolden3SecondsDesc:
          '3 giây đầu tiên của quảng cáo là thời điểm quyết định thành công của quảng cáo.',
        informationTransmission: 'Thời điểm thông tin',
        informationTransmissionDesc:
          'Đánh giá khả năng của thông điệp quảng cáo trong việc thu hút sự chú ý của khán giả mục tiêu và kích thích sự quan tâm.',
        brandRelevance: 'Thời điểm thương hiệu',
        brandRelevanceDesc:
          'Đánh giá khả năng của thời điểm thương hiệu trong việc thu hút sự chú ý của khán giả mục tiêu và kích thích sự quan tâm.',
        interestStimulation: 'Thời điểm quan tâm',
        interestStimulationDesc:
          'Thời điểm quan trọng kích thích phản ứng cảm xúc và nhận thức chủ động của khán giả.',
        theEnding3Seconds: '3 giây cuối',
        theEnding3SecondsDesc:
          'Dựa trên quy luật đỉnh và kết thúc, 3 giây cuối của quảng cáo là thời điểm quan trọng để củng cố sự chú ý của khán giả và tăng cường việc truyền tải thông tin.',
      },
      infoDrawer: {
        basicInformation: 'Thông tin cơ bản',
        advertisingInformation: 'Thông tin quảng cáo',
        projectName: 'Tên dự án',
        brandName: 'Tên thương hiệu',
        category: 'Ngành',
        norm: 'Giá trị chuẩn thị trường mục tiêu',
        normLabel: 'Giá trị chuẩn',
        brandNorm: 'Chuẩn thương hiệu',
        adName: 'Tên quảng cáo',
        taGender: 'Giới tính của TA',
        targetMarket: 'Thị trường mục tiêu',
        taAge: 'Tuổi của TA',
        ageRange: '{{start}} đến {{end}} tuổi',
        modify: 'Sửa',
        cancel: 'Hủy',
        confirm: 'Xác nhận',
      },
      videoView: {
        eyeMovementRatio: 'Chỉ số chú ý',
        cognitiveEngagement: 'Chỉ số nhận thức',
        emotionRecognition: 'Chỉ số cảm xúc',
        subjectiveResponseCurve: 'Đường cong phản ứng chủ quan',
        realtimeData: 'Dữ liệu thực tế',
        panoramicData: 'Dữ liệu pano',
        indexAnalysis: 'Phân tích chỉ số',
        advantage: 'Ưu điểm',
        disadvantage: 'Nhược điểm',
        suggestions: 'Khuyến nghị',
        adVideoScore: 'Chỉ số hiệu quả quảng cáo',
        norm: 'Giá trị chuẩn',
        analysisStepTitle1: 'Giải mã nội dung',
        analysisStepTitle2: 'Dự đoán phản hồi',
        analysisStepTitle3: 'Tích hợp dữ liệu',
        analysisStepTitle4: 'Kết luận và khuyến nghị',
        analysisStepDesc1:
          'Bắt đầu giải mã nội dung quảng cáo đa mô hình, giải mã hình ảnh, giải mã âm thanh, giải mã văn bản, giải mã cấu trúc...',
        analysisStepDesc2:
          'Bắt đầu dự đoán phản ứng chủ quan của khán giả, dựa trên nội dung quảng cáo, dự đoán dữ liệu chuyển động mắt và EEG...',
        analysisStepDesc3:
          'Bắt đầu tích hợp nội dung khách quan của quảng cáo và dữ liệu phản ứng chủ quan của khán giả...',
        analysisStepDesc4:
          'Bắt đầu tạo ra các kết luận và khuyến nghị dựa trên mô hình suy luận...',
        keyResult: 'Kết quả chính',
        videoChart: {
          videoFailed: 'Video không thể phát',
          videoFailedAction: 'Vui lòng thử lại. Nếu vẫn không thể phát, vui lòng liên hệ hỗ trợ.',
        },
      },
      storyboardView: {
        summary: 'Tóm tắt',
        advantages: 'Ưu điểm',
        disadvantages: 'Nhược điểm',
        suggestions: 'Khuyến nghị',
        keyResult: 'Kết quả chính',
        norm: 'Giá trị chuẩn',
        theGolden3Seconds: '3 giây vàng',
        informationTransmission: 'Thời điểm thông tin',
        brandRelevance: 'Thời điểm thương hiệu',
        interestStimulation: 'Thời điểm quan tâm',
        theEnding3Seconds: '3 giây cuối',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'Email',
      username: 'Tên người dùng',
      password: 'Mật khẩu',
      setPasswordToEnableEmailLogin: 'Đặt mật khẩu để kích hoạt đăng nhập bằng email',
      uid: 'UID',
      contactAndReceiveNotifications: 'Liên hệ và nhận thông báo',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'Nhận email về các cập nhật mới nhất của AdEff qua email này.',
      myWorkspace: 'Không gian làm việc của tôi',
      newRequest: 'Yêu cầu mới',
      invitationCode: 'Mã giới thiệu',
      userName: 'Tên người dùng',
      invitationCodeDesc:
        'Mỗi nhóm có một mã mời duy nhất mà người dùng mới sử dụng để yêu cầu tham gia nhóm trong quá trình đăng ký',
      table: {
        userName: 'Tên người dùng',
        email: 'Email',
        operation: 'Hoạt động',
        admin: 'Quản trị viên',
        remove: 'Xóa',
        deny: 'Từ chối',
        approve: 'Chấp thuận',
      },
      message: {
        yourTeamIsFull:
          'Nhóm của bạn đã đầy. Bạn có thể liên hệ với chúng tôi để có thêm thành viên hoặc xóa các thành viên khác.',
        invitationLinkSent: 'Liên kết mời đã được gửi đến địa chỉ email này!',
        removeReminder: 'Nhắc nhở xóa',
        remove: 'Xóa',
        removeMember:
          'Sau khi xóa thành viên, nội dung mà họ tạo sẽ vẫn còn. Bạn có muốn tiếp tục xóa thành viên không?',
        removeMemberSuccess: 'Đã xóa thành viên thành công!',
        ok: 'Được',
        contactUs: 'Liên hệ với chúng tôi',
        applicationProcessedSuccessfully: 'Yêu cầu đã được xử lý thành công!',
        notificationSettingsTurnedOn: 'Cài đặt thông báo đã được bật',
        notificationSettingsTurnedOff: 'Cài đặt thông báo đã được tắt',
        setPassword: 'Đặt mật khẩu',
        passwordConfirm: 'Xác nhận',
        passwordCancel: 'Hủy',
        oldPassword: 'Mật khẩu cũ',
        newPassword: 'Mật khẩu mới',
        pleaseEnterTheOldPassword: 'Vui lòng nhập mật khẩu cũ',
        pleaseEnterTheNewPassword: 'Vui lòng nhập mật khẩu mới',
        incorrectEntryOfOriginalPassword: 'Nhập mật khẩu gốc không chính xác',
        passwordUpdatedSuccessfully: 'Mật khẩu đã được cập nhật thành công',
        changeUsername: 'Thay đổi tên người dùng',
        confirm: 'Xác nhận',
        cancel: 'Hủy',
        username: 'Tên người dùng',
        pleaseEnterTheNewUsername: 'Vui lòng nhập tên người dùng mới',
        userNameUpdatedSuccessfully: 'Tên người dùng đã được cập nhật thành công',
        addMemberToWorkspace: 'Thêm thành viên mới vào không gian làm việc',
        notAdminOperate: 'Không phải quản trị viên, không thể thực hiện thao tác',
        emailAddress: 'Địa chỉ email',
        send: 'Gửi',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'Chúng tôi sẽ gửi một email mời đến địa chỉ này để xác nhận.',
        workspaceMemberShip: 'Thành viên không gian làm việc',
        forMoreMembership: 'Thêm thành viên',
        reachedTheCeiling: 'Đã đạt đến giới hạn.',
        incorrectMailboxFormat: 'Định dạng email không chính xác',
        member: 'Thành viên',
        changeCorpNameTitle: 'Thay đổi tên công ty',
        changeCorpNameLabel: 'Tên công ty',
        pleaseEnterTheCorpName: 'Vui lòng nhập tên công ty',
        changeCorpNameSuccess: 'Tên công ty đã được cập nhật thành công',
        changeCorpNameFailed: 'Tên công ty đã được cập nhật thành công',
        noPermission: 'Bạn không có quyền thay đổi tên công ty',
      },
    },
    subscriptionPage: {
      currentPlan: 'Kế hoạch hiện tại',
      getInvoice: 'Nhận hóa đơn của bạn',
      remainingTimes: 'Số lần còn lại',
      purchaseMore: 'Mua thêm',
      contactUs: 'Liên hệ với chúng tôi',
      teamPlan: 'Dịch vụ của đội ngũ chuyên gia',
      unlimited: 'Không giới hạn',
      dueDate: 'Ngày hết hạn',
      table: {
        usageRecords: 'Bản ghi sử dụng',
        date: 'Ngày',
        projectName: 'Tên dự án',
        projectType: 'Loại dự án',
        usageCount: 'lần',
        userName: 'Tên người dùng',
        noRelevantContent: 'Không tìm thấy nội dung liên quan',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'Dự án sáng tạo thường',
      regularCreative: 'Sáng tạo thường',
      splashCreativeProject: 'Dự án sáng tạo mở màn',
      splashCreative: 'Sáng tạo mở màn',
      projects: 'Dự án',
      localNorm: 'Chuẩn địa phương',
      projectPassRate: 'Tỷ lệ đạt của dự án',
      passRate: 'Tỷ lệ đạt',
    },
    dataDetailPage: {
      baseData: 'Dữ liệu cơ bản',
      totalProjects: 'Tổng số dự án',
      totalProjectsDesc: 'Tổng số dự án tham gia đánh giá hiệu quả quảng cáo.',
      // averageEffectivenessIndex: 'Chỉ số hiệu quả trung bình',
      // averageEffectivenessIndexDesc: 'Chỉ số hiệu quả trung bình của tất cả các dự án hợp lệ.',
      localNormProjects: 'Số lượng dự án chuẩn địa phương',
      brandNormProjects: 'Dự án chuẩn thương hiệu',
      normProject: 'Dự án chuẩn thị trường mục tiêu',
      brandNormProject: 'Dự án chuẩn thương hiệu',
      localNorm: 'Chuẩn địa phương',
      localNormDesc:
        'Chỉ số hiệu quả trung bình của các dự án quảng cáo hợp lệ có thị trường mục tiêu là quốc gia bạn đang ở.',
      norm: 'Chuẩn',
      brandNorm: 'Chuẩn thương hiệu',
      brandNormDesc:
        'Chỉ số hiệu quả trung bình của các dự án quảng cáo hợp lệ có thị trường mục tiêu là chuẩn thương hiệu của bạn.',
      localProjectPassRate: 'Tỷ lệ dự án được chấp thuận địa phương',
      projectPassRate: 'Tỷ lệ dự án được chấp thuận',
      brandProjectPassRate: 'Tỷ lệ dự án được chấp thuận thương hiệu',
      projectPassRateDesc: 'Tỷ lệ dự án được chấp thuận của tất cả các dự án hợp lệ.',
      advertisingEffectivenessIndexDistribution: 'Phân bố chỉ số hiệu quả quảng cáo',
      advertisingEffectivenessIndexDistributionDesc:
        'Phân bố chỉ số hiệu quả quảng cáo của tất cả các dự án hợp lệ.',
      item: 'mục',
    },
    dataComparisonPage: {
      createCompare: 'So sánh mới',
      createCompareDesc: 'Chọn nhiều dự án để so sánh, tối đa 10 dự án.',
      startCompare: 'Bắt đầu so sánh',
      compareReport: 'Báo cáo so sánh',
      searchPlaceholder: 'Tìm tên báo cáo so sánh',
      emptyText: 'Chưa có báo cáo so sánh. Hãy chọn dự án để so sánh trước.',
      searchEmptyText: 'Không tìm thấy báo cáo so sánh.',
      deleteTitle: 'Xóa báo cáo so sánh',
      deleteConfirm: 'Bạn có chắc muốn xóa báo cáo so sánh này không? Không thể hoàn tác thao tác này.',
      projectCount: '{{count}} dự án',
    },
    dataComparisonStartPage: {
      back: 'Quay lại',
      basicInfo: 'Thông tin cơ bản',
      reportName: 'Tên báo cáo:',
      reportNamePlaceholder: 'Nhập tên báo cáo so sánh',
      norm: 'Mốc chuẩn:',
      normPlaceholder: 'Chọn mốc chuẩn',
      normTip: 'Chọn mốc chuẩn dùng để so sánh dự án',
      selectProject: 'Chọn dự án',
      searchPlaceholder: 'Tìm theo tên dự án/quảng cáo/thương hiệu',
      selectedCountPrefix: ' Đã chọn ',
      selectedCountSuffix: ' dự án, tối đa {{max}} dự án',
      startCompare: 'Bắt đầu so sánh',
      save: 'Lưu',
      cancel: 'Hủy',
      maxSelectedWarning: 'Bạn có thể chọn tối đa 10 dự án',
      reportNameRequired: 'Nhập tên báo cáo so sánh',
      normRequired: 'Chọn mốc chuẩn',
      projectRequired: 'Chọn dự án',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'Tên báo cáo so sánh',
      reportNotFound: 'Không tìm thấy báo cáo',
      back: 'Quay lại',
      modify: 'Chỉnh sửa',
      deletedProjectTip: 'Các dự án sau: {{names}} đã bị xóa. Sau khi xác nhận, báo cáo so sánh sẽ được cập nhật và các dự án đã xóa sẽ được loại bỏ.',
      confirmDeletedProjects: 'Xác nhận',
      metricScore: 'Điểm chỉ số',
      tabDimension: 'Năm chiều',
      tabMoment: 'Khoảnh khắc chính',
      tabAttitude: 'Thái độ người tiêu dùng',
      adeffScore: 'Điểm AdEff',
      brandName: 'Tên thương hiệu',
      projectName: 'Tên dự án',
      industry: 'Ngành',
      targetMarket: 'Thị trường mục tiêu',
      gender: 'Giới tính TA',
      age: 'Độ tuổi TA',
      adProject: 'Dự án quảng cáo',
      normLabel: 'Mốc chuẩn',
      mixedCreativeBenchmarkTip: 'Không có benchmark khi so sánh đồng thời creative thông thường và creative splash.',
      emptyProject: 'Chọn dự án để xem dữ liệu so sánh',
      viewProjectDetail: 'Xem chi tiết dự án',
      listSeparator: ', ',
      metricLabels: {
        attention: 'Lực chú ý',
        infectivity: 'Lực cảm xúc',
        delivery: 'Lực thông điệp',
        brand: 'Lực thương hiệu',
        persuasion: 'Lực thuyết phục',
        gazeRecognition: 'Nhận diện ánh nhìn',
        emotionRecognition: 'Nhận diện cảm xúc',
        engagementRecognition: 'Nhận diện tương tác',
        goldenSeconds: '3 giây vàng',
        brandMoment: 'Thời điểm thương hiệu',
        productMoment: 'Thời điểm quan tâm',
        messageMoment: 'Thời điểm thông tin',
        endingSeconds: '3 giây cuối',
        likeability: 'Mức độ yêu thích',
        newInformation: 'Thông tin mới',
        messageRelevance: 'Mức độ liên quan của thông điệp',
        comprehension: 'Mức độ hiểu',
        credibility: 'Độ tin cậy',
        brandLinkage: 'Liên kết thương hiệu',
        uniqueness: 'Tính độc đáo',
        learnMoreIntent: 'Sẵn sàng tìm hiểu thêm',
        purchaseIntent: 'Ý định mua',
        recommendIntent: 'Khả năng chia sẻ',
        brandLikeabilityLift: 'Tăng thiện cảm với thương hiệu',
        purchaseIntentionLift: 'Tăng ý định mua',
        attentionIndex: 'Chỉ số chú ý',
        emotionIndex: 'Chỉ số cảm xúc',
        cognitionIndex: 'Chỉ số nhận thức',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'Dự án đánh giá sáng tạo TVC của bạn đã hoàn tất.',
        title: {
          text1: 'Kiểm thử sáng tạo quảng cáo',
          text2: 'Báo cáo kiểm thử',
        },
        flowAnalysis: {
          desc1: 'AdEff đang phân tích cấu trúc video quảng cáo của bạn',
          desc2: 'Hoàn tất phân tích cấu trúc video',
          desc3: 'Đang phân tích sự chú ý thị giác của người tiêu dùng',
          desc4: 'Đang phân tích điểm tập trung thị giác dựa trên hồ sơ người tiêu dùng',
          desc5: 'Đang tạo bản đồ nhiệt chú ý',
          desc6: 'Đã tạo bản đồ nhiệt động',
          desc7: 'Đang đo phản ứng nhận thức-thần kinh',
          desc8: 'Đang theo dõi ánh nhìn, cảm xúc và mức độ tương tác theo từng giây',
          desc9: 'Đang tạo đường cong phản ứng thần kinh',
          desc10: 'Đã tạo đường cong phản ứng thần kinh',
          desc11: 'Đang phân tích hiệu suất tại các khoảnh khắc chính',
          desc12: 'Đang đo phản ứng nhận thức-thần kinh trong: 3 giây vàng, khoảnh khắc thông điệp, khoảnh khắc thương hiệu, đỉnh quan tâm và 3 giây cuối',
          desc13: 'Đang tổng hợp chỉ số khoảnh khắc chính',
          desc14: 'Hoàn tất phân tích khoảnh khắc chính',
          desc15: 'Đang phân tích thái độ người tiêu dùng',
          desc16: 'Đang phân tích thái độ đối với thương hiệu, sản phẩm và nội dung',
          desc17: 'Đang tổng hợp chỉ số thái độ',
          desc18: 'Hoàn tất chỉ số thái độ',
          desc19: 'Đang tạo điểm năm lực tác động',
          desc20: 'Điểm năm lực tác động đã sẵn sàng',
          desc21: 'Phân tích hoàn tất! Báo cáo hiệu suất quảng cáo của bạn đã sẵn sàng',
          terminology: {
            thumbExpand: 'Mở rộng hình thu nhỏ',
            thumbCollapse: 'Thu gọn hình thu nhỏ',
            gazeRecognition: 'Nhận diện ánh nhìn',
            gazeRecognitionDesc: 'Đo mức độ tập trung chú ý thị giác, cho biết các yếu tố quảng cáo thu hút sự tập trung của người xem hiệu quả đến đâu.',
            emotionRecognition: 'Nhận diện cảm xúc',
            emotionRecognitionDesc: 'Định lượng cảm xúc tích cực và phản ứng cảm xúc tức thời do quảng cáo kích hoạt.',
            engagementRecognition: 'Nhận diện tương tác',
            engagementRecognitionDesc: 'Đo mức độ nhập tâm và tương tác, phản ánh sự đầu tư tinh thần vào nội dung quảng cáo.',
            theGolden3Seconds: 'Hiệu suất 3 giây vàng',
            theGolden3SecondsDesc: 'Đánh giá hiệu quả nội dung quảng cáo trong 3 giây đầu.',
            keyMessage: 'Hiệu suất thông điệp chính',
            keyMessageDesc: 'Đo khả năng các khoảnh khắc thông tin của quảng cáo trong việc thu hút chú ý và kích thích quan tâm.',
            brand: 'Hiệu suất thương hiệu',
            brandDesc: 'Đánh giá khả năng thu hút chú ý dành riêng cho thương hiệu và hiệu quả tương tác.',
            interest: 'Đỉnh quan tâm',
            interestDesc: 'Xác định các điểm cao của nội dung kích hoạt cộng hưởng cảm xúc và tương tác cao.',
            ending3Seconds: 'Hiệu suất 3 giây cuối',
            ending3SecondsDesc: 'Đánh giá hiệu quả nội dung quảng cáo trong 3 giây cuối.',
            score: 'Điểm',
            benchmark: 'Chuẩn so sánh',
            metrics: 'Chỉ số',
            attitudePart: {
              attitudeMetrics: 'Chỉ số thái độ',
              liking: 'Mức độ yêu thích',
              likingDesc: 'Đo thái độ chủ quan và mức độ yêu thích tổng thể của khán giả đối với quảng cáo.',
              newInformation: 'Thông tin mới',
              newInformationDesc: 'Đo liệu khán giả có tin rằng họ nhận được thông tin giá trị, trước đây chưa biết, về thương hiệu hoặc sản phẩm từ quảng cáo hay không.',
              messageRelevance: 'Mức độ liên quan của thông điệp',
              messageRelevanceDesc: 'Đo mức độ khán giả cảm nhận thông tin trong quảng cáo có liên quan trực tiếp đến bản thân họ.',
              comprehension: 'Mức độ hiểu',
              comprehensionDesc: 'Đo liệu thông điệp chính của quảng cáo có được hiểu rõ ràng, chính xác và dễ dàng hay không.',
              credibility: 'Độ tin cậy',
              credibilityDesc: 'Đo mức độ khán giả tin rằng thông tin được truyền tải là đúng, đáng tin cậy và có thể tin tưởng.',
              brandLinkage: 'Liên kết thương hiệu',
              brandLinkageDesc: 'Đo khả năng khán giả liên kết chính xác và mạnh mẽ quảng cáo với thương hiệu cụ thể.',
              uniqueness: 'Tính độc đáo',
              uniquenessDesc: 'Đo liệu quảng cáo có xây dựng được nhận thức rõ ràng rằng thương hiệu có điểm độc đáo nổi bật và giá trị so với đối thủ hay không.',
              willing: 'Sẵn sàng tìm hiểu thêm',
              willingDesc: 'Đo khả năng chủ quan khán giả sẽ chủ động tìm hiểu thêm về thương hiệu hoặc sản phẩm sau khi xem quảng cáo.',
              purchase: 'Ý định mua',
              purchaseDesc: 'Đo khả năng chủ quan khán giả sẽ cân nhắc chọn hoặc mua sản phẩm của thương hiệu trong tương lai.',
              share: 'Khả năng chia sẻ',
              shareDesc: 'Đo khả năng chủ quan khán giả sẽ chủ động chia sẻ quảng cáo hoặc thông tin thương hiệu với người khác.',
              brandLikeLift: 'Tăng thiện cảm với thương hiệu',
              brandLikeLiftDesc: 'Đo hướng và mức độ thay đổi trong thiện cảm tổng thể đối với thương hiệu hoặc sản phẩm sau khi tiếp xúc quảng cáo.',
              purchaseIntentLift: 'Tăng ý định mua',
              purchaseIntentLiftDesc: 'Đo hướng và mức độ thay đổi trong ý định cân nhắc mua sản phẩm của thương hiệu sau khi tiếp xúc quảng cáo.',
            },
            dimensionPart: {
              forceDrives: 'Lực tác động',
              attension: 'Sự chú ý',
              emotionalImpact: 'Tác động cảm xúc',
              messageClarity: 'Độ rõ của thông điệp',
              brandPower: 'Sức mạnh thương hiệu',
              persuasion: 'Sức thuyết phục',
              attentionForce: 'Lực chú ý',
              attentionForceDesc: 'Đo khả năng quảng cáo thu hút và duy trì sự chú ý thị giác và thính giác của khán giả.',
              emotionalForce: 'Lực cảm xúc',
              emotionalForceDesc: 'Đo cường độ cộng hưởng cảm xúc tức thời, bản năng và biến động cảm xúc do nội dung quảng cáo gợi ra.',
              messageForce: 'Lực thông điệp',
              messageForceDesc: 'Đo hiệu quả thông điệp cốt lõi của quảng cáo được nhận diện rõ, hiểu chính xác và ghi nhớ sâu bởi khán giả mục tiêu.',
              brandForce: 'Lực thương hiệu',
              brandForceDesc: 'Đo hiệu quả quảng cáo trong việc củng cố nhận diện thương hiệu, tăng thiện cảm và xây dựng liên kết thương hiệu mạnh.',
              persuasiveForce: 'Lực thuyết phục',
              persuasiveForceDesc: 'Đo sức mạnh cuối cùng của quảng cáo trong việc thay đổi nhận thức và thúc đẩy ý định hành vi.',
            },
            result: {
              results: 'Kết quả',
              pass: 'Đạt',
              notPass: 'Không đạt',
              adeffScore: 'Điểm AdEff',
              adeffScoreDesc: 'Điểm AdEff được thiết kế để đo hiệu quả tổng thể của quảng cáo.',
              benchmarkDesc: 'Điểm AdEff trung bình của tất cả quảng cáo được tải lên trong quốc gia hoặc khu vực của quảng cáo được dùng để so sánh hiệu suất.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'Đang chờ...',
            description: 'Đang tạo báo cáo kiểm thử cho bạn...',
          },
          generating: 'Đang tạo...',
          freeTrialLockText1:
            'Ở chế độ dùng thử, bạn không thể xem trước hoặc tải xuống báo cáo đầy đủ.',
          freeTrialLockText2: 'Đăng ký để mở khóa.',
        },
      },
    },
  },
  professor: {
    account: 'Tài khoản',
    password: 'Mật khẩu',
    login: 'Đăng nhập',
    expertReviews: 'Đánh giá chuyên gia',
    adVideoScore: 'Chỉ số hiệu quả quảng cáo',
    subjectiveResponseCurve: 'Đường cong phản ứng chủ quan',
    indexAnalysis: 'Phân tích chỉ số',
    keyResult: 'Kết quả chính',
    theGolden3Seconds: '3 giây vàng',
    informationTransmission: 'Thời điểm thông tin',
    brandRelevance: 'Thời điểm thương hiệu',
    interestStimulation: 'Thời điểm quan tâm',
    theEnding3Seconds: '3 giây cuối',
    heatMap: 'Bản đồ nhiệt',
    suggestion: 'Khuyến nghị',
    suggestion1: 'Khuyến nghị',
    submit: 'Gửi',
    next: 'Tiếp theo',
    summary: 'Tóm tắt',
    advantages: 'Ưu điểm',
    disadvantages: 'Nhược điểm',
    option1: 'Dự đoán',
    option2: 'Dự đoán không đúng',
    resultJudgment: 'Đánh giá kết quả',
    placeholder: 'Nhập đánh giá',
    waitRateCount: 'Số lượng quảng cáo đang chờ đánh giá',
    unfinishedTitle: 'Lưu ý',
    unfinishedRate:
      'Dự án hiện tại còn các mục chưa được đánh giá, bạn có chắc chắn muốn thoát không?',
    unfinishedConfirm: 'Tiếp tục',
    unfinishedCancel: 'Thoát',
    message: {
      submitSuccess: 'Cảm ơn bạn đã đánh giá',
      submitSuccess1: 'Bạn đã hoàn tất đánh giá dự án này, cảm ơn bạn đã đánh giá',
      loginSuccess: 'Đăng nhập thành công',
      rateUnfinished:
        'Bạn chưa đánh giá nội dung hiện tại, vui lòng điền vào trước khi chuyển sang câu hỏi tiếp theo',
      rateLocation: 'Đã tự động chuyển đến các mục chưa được đánh giá',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'Yêu cầu thử nghiệm miễn phí',
      title1: 'Thử nghiệm miễn phí',
      trial: 'Thử nghiệm',
      hiddenBoxText1: 'Đã phát hiện nhiều ưu điểm, nhược điểm và gợi ý',
      hiddenBoxText2: 'Đăng ký để nhận báo cáo đầy đủ',
      hiddenBoxBtn: 'Đăng ký',
      applyBox: {
        name: 'Tên của bạn',
        tel: 'Số điện thoại',
        department: 'Phòng ban',
        role: 'Vị trí',
        country: 'Quốc gia',
        city: 'Thành phố',
        pleaseEnter: 'Vui lòng nhập',
        pleaseSelect: 'Vui lòng chọn',
        pleaseEnterTheName: 'Vui lòng nhập tên của bạn',
        pleaseEnterTheTel: 'Vui lòng nhập số điện thoại',
        pleaseEnterValidTel: 'Vui lòng nhập số điện thoại hợp lệ',
        pleaseEnterValidEmail: 'Vui lòng nhập email hợp lệ',
        pleaseSelectTheDepartment: 'Vui lòng chọn phòng ban',
        pleaseSelectTheRole: 'Vui lòng chọn vị trí',
        pleaseSelectTheCountry: 'Vui lòng chọn quốc gia',
        pleaseEnterTheCity: 'Vui lòng nhập thành phố',
        textIsRequired: 'Vui lòng nhập',
        submit: 'Gửi',
        tip: 'Mỗi doanh nghiệp chỉ có một lần dùng thử miễn phí',
      },
      gotTrial: 'Bạn đã nhận được thử nghiệm miễn phí!',
      goPc: 'Vui lòng truy cập phiên bản web PC để tạo dự án của bạn.',
      back: 'Quay lại',
      country: {
        China: 'Trung Quốc',
        Japan: 'Nhật Bản',
        Korea: 'Hàn Quốc',
        Indonesia: 'Indonesia',
        Thailand: 'Thái Lan',
        Singapore: 'Singapore',
        Malaysia: 'Malaysia',
        Vietnam: 'Việt Nam',
        Germany: 'Đức',
        Britain: 'Anh',
        France: 'Pháp',
        Italy: 'Ý',
        Russia: 'Nga',
        Spain: 'Tây Ban Nha',
        Turkey: 'Thổ Nhĩ Kỳ',
        America: 'Mỹ',
        Canada: 'Canada',
        Brazil: 'Brazil',
        Other: 'Khác',
      },
      department: {
        Brand: 'Thương hiệu',
        Market: 'Thị trường',
        Marketing: 'Tiếp thị',
        IT: 'IT',
        Procurement: 'Mua hàng',
        Other: 'Khác',
      },
      role: {
        President: 'Tổng giám đốc/Phó tổng giám đốc/Giám đốc',
        CMO: 'CMO hoặc các nhà quản lý cấp cao khác',
        Director: 'Trưởng phòng',
        Manager: 'Trưởng phòng',
        Other: 'Khác',
      },
      message: {
        submitSuccess: 'Cảm ơn bạn đã đánh giá',
        submitFailed: 'Cảm ơn bạn đã đánh giá',
      },
    },
    downloadPptRechargeModal: {
      title: 'Không thể tải xuống',
      desc1: 'Không thể tải xuống trong trạng thái dùng thử',
      desc2: 'Có thể tải xuống báo cáo đầy đủ sau khi đăng ký',
      btn: 'Đăng ký',
    },
    checkInvitationCodeModal: {
      invitationCode: 'Mã giới thiệu',
      invitationCodeDesc1: 'Mã giới thiệu không thể thay đổi, vui lòng liên hệ với chúng tôi',
      invitationCodeDesc2:
        'Nếu bạn đang sử dụng thông qua giới thiệu của đại lý, vui lòng nhập mã giới thiệu',
      invitationCodePlaceholder: 'Vui lòng nhập mã giới thiệu',
      invitationCodeError: 'Mã giới thiệu không hợp lệ',
      invitationCodeSuccess: 'Mã giới thiệu đã được thay đổi thành công',
      ok: 'Được',
      cancel: 'Hủy',
    },
    aigcPromotionModal: {
      title: 'Ưu đãi cho nhà sáng tạo AIGC',
      subTitle: 'Đăng ký ngay để nhận <tmp>5</tmp> cơ hội đánh giá video AI',
      desc1:
        'Tham gia sự kiện AdEff AI Creative Testing để đánh giá các nội dung sáng tạo của bạn.',
      desc2: 'Đăng ký ngay và nhận ngay 5 lượt kiểm tra miễn phí.',
      registerBtn: 'Đăng ký để nhận cơ hội thử nghiệm',
      tip: 'Chỉ áp dụng cho người dùng mới đăng ký qua cổng chiến dịch Nhà sáng tạo AIGC',
      floatTitle: 'Kiểm thử miễn phí',
    },
  },
}

export default TRANSLATION
